module.exports = __webpack_public_path__ + "static/background_primary-f880ab1a9aa7519599bcc98302e969dc.png";